import React, { Component } from 'react';
import PropTypes from 'prop-types';

const DatComplete = (props) => {
  return (
    <form action='' className='checkout__form'>
      <h2>Thank you</h2>
      <p className='checkout__confirm-message'>
        You will receive an email to confirm we have assigned you to a tutor and then you can start learning straight away! In the meantime, please click on the links below to take a look through our advice about using the BSL Courses learning interface:<br /><br />
        <ul>
          <li><a href='http://support.bslcourses.co.uk/customer/portal/articles/506054-watch-a-video' target='_blank' rel='noopener noreferrer'>How to watch a video</a></li>
          <li><a href='http://support.bslcourses.co.uk/customer/portal/articles/506091-book-a-tutorial' target='_blank' rel='noopener noreferrer'>How to book a tutorial</a></li>
          <li><a href='http://support.bslcourses.co.uk/customer/portal/articles/505929-book-an-assessment' target='_blank' rel='noopener noreferrer'>How to book an assessment (if you are on a qualification course)</a></li>
          <li><a href='http://support.bslcourses.co.uk/customer/portal/articles/506356-upload-evidence' target='_blank' rel='noopener noreferrer'>How to upload evidence (if asked by your tutor)</a></li>
        </ul>
      </p>
      <p className='u-text-center'><a onClick={props.onSubmit} className='button button--xl button--shadow'>Start learning now</a></p>
    </form>
  );
};

/* -- for when there was a waiting list
const WaitingComplete = () => {
  return (
    <form action='' className='checkout__form'>
      <h2>Thank you</h2>
      <p className='checkout__confirm-message'>
        <p> Many thanks for registering your interest in this course. You have now been added to the waiting list.</p>
        <p>You should receive an email containing an invoice soon, you do not need to pay until we have notified you when a space has become available on your course</p>
        <p>In the meantime, please feel free to contact us if you have any questions, or click on the links below to take a look through our advice about using the BSL Courses learning interface:<br /><br /></p>
        <ul>
          <li><a href='http://support.bslcourses.co.uk/customer/portal/articles/506054-watch-a-video' target='_blank' rel='noopener noreferrer'>How to watch a video</a></li>
          <li><a href='http://support.bslcourses.co.uk/customer/portal/articles/506091-book-a-tutorial' target='_blank' rel='noopener noreferrer'>How to book a tutorial</a></li>
          <li><a href='http://support.bslcourses.co.uk/customer/portal/articles/505929-book-an-assessment' target='_blank' rel='noopener noreferrer'>How to book an assessment (if you are on a qualification course)</a></li>
          <li><a href='http://support.bslcourses.co.uk/customer/portal/articles/506356-upload-evidence' target='_blank' rel='noopener noreferrer'>How to upload evidence (if asked by your tutor)</a></li>
        </ul>
      </p>
    </form>
  );
}; -- */

class Complete extends Component {
  render () {
    const completePage = <DatComplete onSubmit={this.props.onSubmit} />;

    /* -- for when there was a waiting list
    var completePage = <WaitingComplete />;
    if (this.props.checkoutState.course.title.indexOf('Level 1') > -1 ||
    this.props.checkoutState.course.type === 'independent') {
      completePage = <DatComplete onSubmit={this.props.onSubmit} />;
    } -- */

    return (
      <span>
        {completePage}
      </span>
    );
  }
}

Complete.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  checkoutState: PropTypes.object.isRequired
};

export default Complete;



// WEBPACK FOOTER //
// ./src/views/Checkout/Complete/index.js